export enum SortType {
  Asc = "asc",
  Desc = "desc"
}

export enum HttpMethodEnum {
  GET = "get",
  POST = "post",
  PUT = "put",
  DELETE = "delete",
  OPTION = "option"
}

export enum TaskScope {
  APPLICATION = 'Application',
  TASK = 'Task'
}

export enum TaskDataRefreshStrategy {
  CLEANUP = 'Cleanup',
  OVERRIDE = 'Override',
  OPT_OUT = 'OptOut'
}

export enum TaskStatusEnum {
  EXECUTING = "executing",
  TIMEOUT = "timeout",
  RESUMING = "resuming",
  COMPLETED = "completed",
  FAILED = 'failed'
}

export enum LogicalOperator {
  AND = "and",
  OR = "or"
}

export enum MyApColorTheme {
  WHITE = "White",
  BLUE = "Blue",
  GREEN = "Green",
  DARK = "Dark"
};

export enum DateTimeFormatStrings {
  FORMAT_1 = 'YYYY-MM-DD',
  FORMAT_2 = 'MM-yyyy',
  FORMAT_3 = 'DD.MM.YYYY',
  FORMAT_4 = 'DD/MM/YYYY',
  FORMAT_5 = 'YYYYMM',
  FORMAT_6 = 'yyyy-MM-dd',
  FORMAT_7 = 'YYYYMMDD',
  FORMAT_8 = 'HH:mm:ss',
  FORMAT_9 = 'YYYY-MM-DD HH:mm:ssXXX', // Add Time Zone
  FORMAT_10 = 'YYYY-MM-DDT00:00:00Z', // Only have date value
  FORMAT_11 = 'YYYY-MM-DDTHH:mm:ssZ',
  FORMAT_12 = 'YYYY-MM-DD HH:mm:ss'
}

export enum CsvImportType {
  IT_TOOLS_USAGE = "ITToolsUsage",
  DRIVING_BEHAVIOR = "DrivingBehavior",
  KPI_ECONOMY = "KpiEconomy",
  ACHIEVEMENT = "Achievement",
  AWARD = "Award"
}

export enum SpecialProcessCsvColumn {
  KPI_DATE = "kpidate",
  KPI_TIME = "kpitime",
  COMPLIANCE = "compliance",
  OCCURRENCE = "occurrence",
  TARGETOCCURRENCE = "targetoccurrence",
  ROWNUM = "rowNum",
  DURATION = "duration",
  SPEED = "speed",
  KPISCORE = "kpiscore",
  KPIVALUE = "kpivalue",
  MILEAGE = "mileage",
  CYLINDER = "cylinder",
  ACHIEVE_DATE = "achieveDate",
  AWARD_DATE = "awarddate",
  GPS_MONITOR = "gpsmonitor",
  DESCRIPTION = "description"
}

export enum Status {
  ACTIVE = "A",
  INACTIVE = "I"
}

export enum TeamMessageReceiverType {
  COUNTRY = "country",
  SUB_REGION = "subRegion",
  TERMINAL = "terminal",
  DRIVER = "driver",
  UNKNOW = 'unknow'
}

export enum DMPRole {
  SYSTEM_ADMIN = 1,
  DRIVER_ADMIN = 2,
  SUPERVISOR = 3
}

export enum DriverDataBusinessType {
  LB = "LB",
  MB = "MB",
  PG = "PG",
  LB_MB = "LB/MB",
}

export enum KPINameNameIdMapping {
  DRIVER_OBSERVATION = "B006",
  EVCR_COMPLIANCE = "I001",
  APT_COMPLIANCE = "I002",
  SAFETY_MEETING_COMPLIANCE = "I005",
  FUEL_CONSUMPTION_RATE = "E001",
  ECONOMY_ENGINE_SPEED_RATE = "E002"
}
